import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46cd7086"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { queryDeviceThingSubDeviceListById } from '@/api'
import { CODE_ENUM, PRODUCT_TYPE } from '@/common'
import subDevicecommandRecordDrawer from './sub-device-command-record-drawer.vue'
import subDevicecommandDrawer from './sub-device-command-drawer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'sub-device-table',
  props: ['data'],
  setup(__props) {

const tableData = ref([])
const tableLoading = ref(false)

const $route = useRoute()

const props = __props

const deviceId = $route.query.deviceId || ''

const fetchList = async () => {
  const res: any = await queryDeviceThingSubDeviceListById({
    gatewayDeviceId: deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res.data || []
  }
}

const isDirectDevice = ref(false)

onMounted(() => {
  if (PRODUCT_TYPE.DIRECT_CONNECT === props.data?.productTypeCode) {
    isDirectDevice.value = true
    return
  }
  fetchList()
})

const col: any = [
  {
    type: 'index',
    label: '序号',
    width: 60,
  },
  {
    prop: 'deviceName',
    label: '子设备名称',
  },
  {
    prop: 'producer',
    label: '厂家',
  },
  {
    prop: 'brand',
    label: '品牌/型号',
    formatter: ({ brand, productModel }: any) => {
      return [brand, productModel].filter(Boolean).join('/') || '-'
    },
  },
  {
    prop: 'deviceSn',
    label: '端口号/SN',
  },
  {
    prop: 'variable',
    label: '属性',
  },
]

const commandConf = ref({
  visible: false,
  data: {},
})

const handleCommand = ({ deviceId }: any) => {
  commandConf.value = {
    visible: true,
    data: {
      deviceId,
    },
  }
}

const commandRecordConf = ref({
  visible: false,
  data: {},
})

const handleCommandRecord = ({ deviceId }: any) => {
  commandRecordConf.value = {
    visible: true,
    data: {
      deviceId,
    },
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (isDirectDevice.value)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "无数据"
          }))
        : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: tableData.value,
            class: "ws_common_table ws_mt24"
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, { description: "暂无数据" })
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item) => {
                return _createVNode(_component_el_table_column, _mergeProps({
                  key: item.prop
                }, { ...item }, { "show-overflow-tooltip": "" }), null, 16)
              }), 64)),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "180"
              }, {
                default: _withCtx((scoped) => [
                  (scoped.row.instructFlag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (handleCommand(scoped.row)),
                          class: "command-span"
                        }, "命令下发", 8, _hoisted_3),
                        _createVNode(_component_el_divider, {
                          direction: "vertical",
                          class: "ws_ml15 ws_mr15"
                        }),
                        _createElementVNode("span", {
                          onClick: ($event: any) => (handleCommandRecord(scoped.row)),
                          class: "command-span"
                        }, "下发记录", 8, _hoisted_4)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, tableLoading.value]
          ])
    ]),
    _createVNode(subDevicecommandDrawer, {
      visible: commandConf.value.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((commandConf.value.visible) = $event)),
      data: commandConf.value.data
    }, null, 8, ["visible", "data"]),
    _createVNode(subDevicecommandRecordDrawer, {
      visible: commandRecordConf.value.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((commandRecordConf.value.visible) = $event)),
      data: commandRecordConf.value.data
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})